import {Vector2} from "../js/delme_globals";
import globalsObject from "../js/globalsObject";
import {EventVerteiler} from "./eventVerteiler";

export class SelectableObjectInsertionPointFinder {
    private readonly getPartAndUVUnderCenter: ()=>{partname, u, v};
    private getDroppablePartNames: () => string[];

    public constructor(getPartAndUVUnderCenter:()=>{partname, u, v}, getnDroppablePartNames:()=>string[]) {
        this.getPartAndUVUnderCenter = getPartAndUVUnderCenter;
        this.getDroppablePartNames = getnDroppablePartNames;
    }

    public getInsertionPoint() {
        const result =  this.getPartAndUVUnderCenter();
        const droppablePartNames = this.getDroppablePartNames();
        if(droppablePartNames.indexOf(result.partname) === -1) {
            let partToInsert = droppablePartNames.find(n=>n.indexOf("ront")>-1);
            if(partToInsert === undefined) {
                partToInsert = droppablePartNames[0];
            }
            if(partToInsert) {
                EventVerteiler.broadcast("SelObBackupInsertionEvent", {part:partToInsert})
                return {
                    part:partToInsert,
                    position: new Vector2(0.5, 0.5)
                }
            }
        }
        return {
            part:result.partname,
            position:new Vector2(result.u, result.v)
        };

    }
}
